module.exports = __webpack_public_path__ + "static/media/icon-dashboard-feedback.c0f25ccd.svg";